module.exports = __webpack_public_path__ + "img/99.001a2dd9.jpg";